import React, {useEffect, useState} from "react";
import "./TradingCupLeaderboard.scss";

import {useDispatch, useSelector} from "react-redux";
import LoaderOverlay from "../../reusableComponents/Loader";
import {removeLastPayment, setPaymentStatus} from "../../store/reducers/accountSlice";

import ErrorModal from "../../reusableComponents/ErrorModal";
import SuccessModal from "../../components/reusableComponents/SuccessModal";
import {baseUrl} from "../../utils/apis";
import axios from "axios";
import TradingCupTable from "./TradingCupTable";

function TradingCupLeaderboard() {
  const dispatch = useDispatch();
  const items = [
    {
      name: "All",
      path: "all",
    },
    // {
    //   name: "Received",
    //   path: "received",
    // },
    // {
    //   name: "Transfer",
    //   path: "transfer",
    // },
  ];
  const idToken = useSelector((state) => state.auth.idToken);
  // useEffect(() => {
  //   dispatch(getPaymentHistory(idToken));
  // }, []);

  const [leaderboardData, setLeaderboardData] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");

  // Fetch leaderboard API
  const fetchTradingCupLeaderboard = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/account/leaderboard/trading-cup/`, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      });

      if (response?.data) {
        setLeaderboardData(response.data);
      } else {
        setErrorMsg("No leaderboard data found.");
        setErrorModalOpen(true);
      }
    } catch (error) {
      console.error("Error fetching leaderboard:", error);
      setErrorMsg(error.response?.data?.message || "Something went wrong.");
      setErrorModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch leaderboard on mount
  useEffect(() => {
    fetchTradingCupLeaderboard();
    window.scrollTo(0, 0);
  }, []);

  const paymentHistory = useSelector((state) => state.account.paymentHistory);
  const [isLoading, setIsLoading] = useState(paymentHistory.loading);
  const [errorModalOpen, setErrorModalOpen] = useState(paymentHistory.error);
  useEffect(() => {
    setErrorModalOpen(paymentHistory.error);
    setIsLoading(paymentHistory.loading);
    window.scrollTo(0, 0);
  }, [paymentHistory]);
  useEffect(() => {
    if (paymentHistory?.lastPayment?.data?.id) {
      dispatch(removeLastPayment());
    }
  }, [paymentHistory.lastPayment?.data?.id]);

  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);
  const accountList = useSelector((state) => state?.account?.accountList?.data);
  let msg = accountList?.length > 0 ? "Congratulations! Payment was successful" : "You'll shortly receive an email with your account login credentials";
  const {isPaymentDone} = useSelector((state) => state.account.paymentHistory);
  const challengeId = useSelector((state) => state.account.selectedChallenge);

  return (
    <>
      {isLoading && <LoaderOverlay />}
      {isPaymentDone === true && (
        <SuccessModal
          setModalOpen={() => dispatch(setPaymentStatus(null))}
          title="Successful!"
          desc={msg}
          btnText="Close"
        />
      )}
      {/* <Tabination
        variant={3}
        tabItems={items}
        activeTab={0}
        style={{margin: "0 14px"}}
      /> */}
      <div className="paymenthistory">
        <h2>Trading Cup Leaderboard</h2>
        {errorModalOpen && (
          <ErrorModal
            desc={paymentHistory.message}
            setModalOpen={setErrorModalOpen}
            btnText="Cancel"
          />
        )}

        <TradingCupTable
          loading={isLoading}
          leaderboardData={leaderboardData}
        />
        {/* <Routes>
          <Route
            path="/"
            element={
              <Navigate
                to="all"
                replace={true}
              />
            }
          />
          <Route
            path="all"
            element={<PaymentHistoryTable />}
          />
          <Route
            path="received"
            element={<PaymentHistoryTable />}
          />
          <Route
            path="transfer"
            element={<PaymentHistoryTable />}
          />
        </Routes> */}
      </div>
    </>
  );
}

export default TradingCupLeaderboard;
